import React from 'react';

class ErrorBoundary extends React.Component {
    // eslint-disable-next-line
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error, errorInfo) {
        // @TODO You can also log the error to an error reporting service (DataDog?)
        // eslint-disable-next-line
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // @TODO render fallback UI
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
